export default __webpack_public_path__ + "static/media/logo.87914584.png";